var _path, _circle, _path2, _g, _path3, _path4, _path5, _path6, _rect, _circle2, _rect2, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCds15MonthHardBlockIcon = function SvgCds15MonthHardBlockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 227,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "cds-15-month-hard-block-icon_svg__a",
    width: 223,
    height: 228,
    x: 0,
    y: -1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.648-.007h221.626v226.594H.648z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cds-15-month-hard-block-icon_svg__a)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 111.116,
    cy: 115.774,
    r: 110.813,
    fill: "#EFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cds-15-month-hard-block-icon_svg__b",
    width: 227,
    height: 247,
    x: -2,
    y: -20,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M224.533 111.846c0 63.37-50.624 114.741-113.072 114.741S-1.612 175.216-1.612 111.846 21.985-21.098 119.46-19.465c62.448 0 105.073 67.942 105.073 131.311"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cds-15-month-hard-block-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCFBB",
    d: "M15.91 192.446c-.316-3.508-1.818-85.025 32.037-132.269 17.666 10.87 6.883 26.55 8.022 41.639s.854 25.055 4.042 40.767 14.724 28.19 15.097 33.265l59.476-.894c-18.425 59.78-49.357 26.647-74.798 72.902l-63.237.158 1.246-34.879z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 109.563,
    height: 209.49,
    fill: "#125A42",
    rx: 10,
    transform: "matrix(1 .00236 -.00165 1 58.25 -.142)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 93.049,
    height: 191.614,
    fill: "#FAFAFA",
    rx: 8,
    transform: "matrix(1 .00238 -.00163 1 66.153 9.09)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#EFE",
    strokeLinecap: "round",
    d: "M99.962 3.45h25.803"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 14,
    x: 73.54,
    y: 114.041,
    fill: "#125A42",
    rx: 7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 14,
    x: 73.54,
    y: 114.041,
    stroke: "#125A42",
    strokeWidth: 2,
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#92DE63",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "m95.282 115.196 9.813 5.184"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCFBB",
    d: "m170.984 295.14 91.499 5.04-13.332-22.781c-3.59-5.756-2.436-19.106-2.113-25.52 1.284-17.982-7.21-36.608-13.001-47.333-4.652-9.246-14.412-9.118-18.711-7.898-5.61-7.489-12.697-6.249-17.015-4.683-9.275-6.031-15.993-4.35-21.521-2.227-9.565-7.555-16.827-4.326-21.336-1.799l-30.907-58.516c-4.863-10.576-9.38-9.896-12.989-8.601-4.416 1.589-4.693 7.21-3.931 9.749l20.157 68.539c3.552 11.92 2.47 31.559 3.79 44.537 2.295 18.773 27.229 42.151 39.41 51.493"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#92DE63",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "m107.351 106.121 4.11 10.274M123.395 106.76l-4.951 9.635"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M144.068 90.076V41.289h-33.955v48.787z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M141.409 47.954h-28.222v2.864h28.222zM139.873 53.315h-25.272v2.65h25.272z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#92DE63",
    fillRule: "evenodd",
    d: "M139.217 65.802 123.25 81.768l-7.993-7.993 4.027-4.027 3.966 3.966 11.94-11.94z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.765,
    height: 27.344,
    x: 81.357,
    y: 62.275,
    fill: "#169B62",
    stroke: "#169B62",
    rx: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.739,
    cy: 73.584,
    r: 3.089,
    fill: "#fff",
    stroke: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.738,
    height: 9.401,
    x: 94.87,
    y: 72.086,
    fill: "#fff",
    stroke: "#fff",
    rx: 1.869
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#169B62",
    strokeWidth: 3.2,
    d: "M88.313 57.98a8.427 8.427 0 0 1 16.854 0v7.579H88.313z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M101.902 58.455h5.875v3.319h-5.875z"
  })));
};
export { SvgCds15MonthHardBlockIcon as ReactComponent };
export default __webpack_public_path__ + "images/cds-15-month-hard-block-icon.svg";